import { default as CandidateType, CandidateProfileType } from '../../model/hros/recruiting/CandidateType';
import { CombinedAddressType } from '../../model/hros/common/communication/AddressTypeArray';
import { default as EducationAttendanceType, EducationDegreeType, EducationSpecializationType } from '../../model/hros/common/profile/EducationAttendanceType';
import OrganizationType from '../../model/hros/common/organization/OrganizationType';
import AddressComponentType from '../../model/hros/common/communication/AddressComponentType';
import { EducationIsEmpty } from '../../components/profile';
import { IEducationInstanceForm } from '../../model/forms';
import { DefaultTypeIdentifiersCodeList } from '../../model/hros/common/codelist/DefaultTypeIdentifiersCodeList';
import { FormatAddress } from './FormatAddress';

export function ProfileFormEducationsToHROS(src: Map<number, IEducationInstanceForm>, dest: CandidateType) : boolean {
  let educations: EducationAttendanceType[] = [];
  if (src.size !== 0) {
    src.forEach((value: IEducationInstanceForm) => {
      if (EducationIsEmpty(value)) {
        return;
      }

      let education: EducationAttendanceType = {};
      let educationModified = false;
      let institution: OrganizationType = {};
      let institutionModified = false;

      if (value.schoolName !== undefined) {
        institution.name = value.schoolName;
        institutionModified = true;
      }

      let formattedAddress = FormatAddress(undefined, value.city, value.state, value.postalCode, undefined);
      if (formattedAddress !== undefined) {
        let address: CombinedAddressType = {
          formattedAddress: formattedAddress
        };

        if (value.city !== undefined) {
          address.city = value.city.trim();
        }

        if (value.postalCode !== undefined) {
          address.postalCode = value.postalCode.trim();
        }

        if (value.state !== undefined) {
          address.countrySubDivisions = [
            {
              type: DefaultTypeIdentifiersCodeList.COUNTRY_SUB_DIVISION_STATE,
              value: value.state.trim()
            }
          ];
        }

        institution.communication = {
          address: [ address ]
        };
        institutionModified = true;
      }

      if (institutionModified) {
        education.institution = institution;
        educationModified = true;
      }

      if (value.enrollmentStart !== undefined) {
        education.start = value.enrollmentStart.trim();
        educationModified = true;
      }

      if (value.enrollmentEnd !== undefined) {
        education.end = value.enrollmentEnd.trim();
        educationModified = true;
      }

      let educationDegreeType: EducationDegreeType = {};
      let educationDegreeTypeModified = false;
      
      if (value.degreeType !== undefined) {
        educationDegreeType.iscedEducationLevelCode = parseInt(value.degreeType.trim());
        educationDegreeTypeModified = true;
      }

      if (value.fieldOfStudy !== undefined) {
        educationDegreeType.specializations = [
          {
            type: DefaultTypeIdentifiersCodeList.EDUCATION_DEGREE_TYPE_SPECIALIZATIONS_FIELD_OF_STUDY,
            name: value.fieldOfStudy.trim()
          }
        ];        
        educationDegreeTypeModified = true;
      }

      if (educationDegreeTypeModified) {
        education.educationDegrees = [ educationDegreeType ];
        educationModified = true;
      }

      if (educationModified) {
        educations.push(education);
      }
    });
  }

  if (educations.length === 0) {
    return false;
  }

  dest.profiles![0].education = educations;
  return true;
}

export function HROSToProfileFormEducations(src: CandidateType, dest: Map<number, IEducationInstanceForm>) {
  if (src?.profiles === undefined || src.profiles.length === 0) {
    return;
  }

  let profile = src.profiles.find((value: CandidateProfileType) => value.profileId?.schemeId === DefaultTypeIdentifiersCodeList.CANDIDATE_PROFILE_TYPE_DEFAULT) || src.profiles[0];
  if (profile.education === undefined || profile.education.length === 0) {
    return;
  }
  profile.education.forEach((value: EducationAttendanceType) => {
    let education: IEducationInstanceForm = {
      instanceId: dest.size + 1
    };
    let educationModified = false;

    if (value.institution?.name != undefined) {
      education.schoolName = value.institution.name;
      educationModified = true;
    }

    if (value.institution?.communication?.address?.[0]?.city !== undefined) {
      education.city = value.institution.communication.address[0].city;
      educationModified = true;
    }

    if (value.institution?.communication?.address?.[0]?.postalCode !== undefined) {
      education.postalCode = value.institution.communication.address[0].postalCode;
      educationModified = true;
    }

    if (value.institution?.communication?.address?.[0]?.countrySubDivisions !== undefined) {
      let state = value.institution.communication.address[0].countrySubDivisions.find((value: AddressComponentType) => !!value.type && value.type.toUpperCase() === DefaultTypeIdentifiersCodeList.COUNTRY_SUB_DIVISION_STATE);
      if (state?.value !== undefined) {
        education.state = state.value;
        educationModified = true;
      }
    }

    if (value.start !== undefined) {
      education.enrollmentStart = value.start;
      educationModified = true;
    }

    if (value.end !== undefined) {
      education.enrollmentEnd = value.end;
      educationModified = true;
    }

    if (value.educationDegrees?.[0]?.iscedEducationLevelCode !== undefined) {
      education.degreeType = value.educationDegrees[0].iscedEducationLevelCode.toString();
      educationModified = true;
    }

    if (value.educationDegrees?.[0]?.specializations !== undefined) {
      let fieldOfStudy = value.educationDegrees[0].specializations.find((value: EducationSpecializationType) => value.type?.toUpperCase() === DefaultTypeIdentifiersCodeList.EDUCATION_DEGREE_TYPE_SPECIALIZATIONS_FIELD_OF_STUDY);
      if (fieldOfStudy?.name !== undefined) {
        education.fieldOfStudy = fieldOfStudy.name;
        educationModified = true;
      }
    }

    if (educationModified) {
      dest.set(education.instanceId, education);
    }
  });
}